export default __webpack_public_path__ + "static/media/beginning.a89a5668.md";